import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ToastService } from "@app/services";
import { StateStatus } from "@app/state/model";
import { selectDiveLogLinesStatus } from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { filter, map, take, tap } from "rxjs";

export const logLineGuard: CanActivateFn = () => {
  const store = inject(Store);
  const toast = inject(ToastService);
  return store.select(selectDiveLogLinesStatus).pipe(
    tap((status) => {
      switch (status) {
        case StateStatus.Pending:
          toast.show("Dive Log Lines pending to load...");
          break;
        case StateStatus.Loading:
          toast.show("Dive Log Lines loading...");
          break;
        case StateStatus.Error:
          toast.show("Dive Log Lines failed to load...");
          break;
      }
    }),
    filter(
      (status) =>
        status === StateStatus.Success || status === StateStatus.Error
    ),
    map((status) => status === StateStatus.Success),
    take(1)
  );
};
